<template>
  <ReportWrapper :is-downloading="loading" @download="downloadPdf" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { downloadFile } from '@/helpers/download';
import ImportReportsService from '@/services/reports/reports.service';
import { useToggle } from '@/composables/useToggle';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'PendingContainers',
  components: {
    ReportWrapper,
  },
  setup() {
    // const { useDownloadInternalInventoryReport } = useReports();
    // const { mutateAsync: downloadReport } = useDownloadInternalInventoryReport();

    const [loading, toggleLoading] = useToggle();
    const downloadPdf = async () => {
      try {
        toggleLoading(true);
        const {
          data: { base64Data, filename },
        } = await ImportReportsService.downloadPendingContainersReport();
        if (!base64Data) return;

        downloadFile(base64Data, filename);
      } catch (e) {
        console.log(e);
      } finally {
        toggleLoading(false);
      }
    };

    return { loading, downloadPdf };
  },
});
</script>
